import { saveAs } from "@progress/kendo-file-saver";

export const saveFile=(data:any,fileName:string)=>{
    saveAs(data,fileName);
}